var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"panel-header__logo",on:{"click":function($event){return _vm.goto({ name: 'MyAccount' })}}},[_c('img',{staticClass:"logo__img",attrs:{"src":_vm.brandLogos.panel}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_vm._t("account-speed-management")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6654ac2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/PanelHeader/index.vue
// module id = 1279
// module chunks = 2